import { Stack, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import { AccessDeniedImage, AccessDeniedImage2x } from '../assets/images';

export const AccessDenied: React.FC<PropsWithChildren> = ({ children }) => (
  <Stack flex={1} alignItems="center">
    {children}
    <Stack flex={1} p={4} justifyContent="center" alignItems="center">
      <picture>
        <source srcSet={`${AccessDeniedImage}, ${AccessDeniedImage2x} 2x`} />
        <img className="LandingLayout__image" src={AccessDeniedImage} alt="Access denied" />
      </picture>
      <Typography variant="h1" mb={0.5} align="center">
        <FormattedMessage id="accessDenied" />
      </Typography>
      <Typography align="center">
        <FormattedMessage id="pleaseContact" />
      </Typography>
    </Stack>
  </Stack>
);
